import {useState} from "react";
import {Plus} from "lucide-react";
import {ActiveSwitch, errMsg, Field, FormActions} from "@/components/cms/common";
import {ServicePicker} from "@/components/booking/ServicePicker";
import {money} from "@/lib/inner";

export const PackagesTab = ({items, services, categories, call, reload}) => {
  const [edit, setEdit] = useState(null), [saving, setSaving] = useState(false);
  const set = (k, v) => setEdit(x => ({...x, [k]: v}));
  const byId = id => services.find(s => s.id === id);
  const toggle = id => setEdit(x => ({...x, service_ids: x.service_ids.includes(id) ? x.service_ids.filter(i => i !== id) : [...x.service_ids, id]}));
  const save = async e => {
    e.preventDefault();
    if (!edit.service_ids.length) return alert("Pilih minimal satu perawatan.");
    setSaving(true);
    try { const {id, name, description, service_ids, active} = edit; await call("put", `/packages/${id}`, {name, description, service_ids, active}); setEdit(null); reload(); } catch (err) { alert(errMsg(err)); }
    setSaving(false);
  };
  const remove = async p => { if (window.confirm(`Hapus paket ${p.name}?`)) { await call("delete", `/packages/${p.id}`); reload(); } };
  return <div>
    <div className="cms-toolbar"><p className="muted">Paket favorit tampil di langkah pertama booking dan dipilih pelanggan dengan sekali ketuk.</p><button className="primary-btn" data-testid="cms-package-add" onClick={() => setEdit({id: "new", name: "", description: "", service_ids: [], active: true})}><Plus size={16}/> Tambah paket</button></div>
    {edit && <form className="cms-form" onSubmit={save} data-testid="cms-package-form">
      <h3>{edit.id === "new" ? "Paket favorit baru" : `Ubah ${edit.name}`}</h3>
      <div className="cms-grid">
        <Field label="Nama paket" testid="cms-package-name" value={edit.name} onChange={e => set("name", e.target.value)} required/>
        <Field label="Deskripsi singkat" testid="cms-package-description" value={edit.description} onChange={e => set("description", e.target.value)}/>
      </div>
      <p className="field-label">Isi paket ({edit.service_ids.length}) · {money(edit.service_ids.reduce((a, id) => a + (byId(id)?.price || 0), 0))}</p>
      <ServicePicker services={services} categories={categories} selected={edit.service_ids.map(byId).filter(Boolean)} onToggle={toggle}/>
      <ActiveSwitch testid="cms-package-active" checked={edit.active} onChange={v => set("active", v)}/>
      <FormActions testid="cms-package" saving={saving} onCancel={() => setEdit(null)}/>
    </form>}
    <div className="cms-cards">{items.map(p => {
      const list = p.service_ids.map(byId).filter(Boolean);
      return <article className="cms-card pkg" key={p.id} data-testid={`cms-package-${p.id}`}>
        <div><h4>{p.name} {!p.active && <span className="off-chip">Disembunyikan</span>}</h4><p>{list.map(s => s.name).join(" + ") || "Perawatan tidak tersedia"}</p><small>{money(list.reduce((a, s) => a + s.price, 0))}</small></div>
        <div className="cms-row-actions"><button data-testid={`cms-package-edit-${p.id}`} onClick={() => setEdit(p)}>Ubah</button><button className="danger" data-testid={`cms-package-delete-${p.id}`} onClick={() => remove(p)}>Hapus</button></div>
      </article>;
    })}</div>
  </div>;
};
